module.exports = __webpack_public_path__ + "static/media/health.70942e0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/TeamBox/img/health.svg
// module id = 80
// module chunks = 0